import React, { useMemo } from 'react'
import Search from '../search';
import { utils } from '@sui/runtime';
import { getChatUrl } from '@/utils/public';
import "./index.less"

export default function AgentsList() {
    const embed = useMemo(() => {
        const _embed = utils.getQueryParam('embed')
        return _embed == '1' || _embed == 'true'
    }, [])
    return (
        <div className='nlSearch'>
            <Search
                onClick={(key) => {
                    if (key?.outerznt) {
                        window.open(key?.outerurl);
                    } else {
                        // swtichZnt(key?.key ?? "");
                        window.open(getChatUrl(key?.key ?? "", embed, false), '_agent')
                    }
                    //navigate(`chat?znwdId=${key?.key ?? ""}`)
                }}
            ></Search>
        </div>

    )
}
